<div>
    Use the filters to search the catalog for courses. Only courses that match all of your search criteria will be displayed.
    <br /><br />For example if you select the following days: Sun, Wed, Sat. Only the courses with sections which occur on all of those days will show.
    <br /><br />The instructors, meeting times, terms and credits will be displayed for each section.
    <br /><br />If available, the instructor role will also be displayed:
    <ul>
        <li>
            <strong>Lead Instructor:</strong> For online courses, the professor who created the asynchronous material used to teach the course.
        </li>
        <li>
            <strong>Coordinating instructor:</strong> For online courses, the instructor who coordinates the teaching activity for the course.
        </li>
        <li>
            <strong>Section instructor:</strong> For residential courses, the professor who delivers the course in the classroom. For online courses, the professor who teaches the live sessions of the course.
        </li>
    </ul>
</div>
<hr />
<p><strong>Week Days Abbreviations</strong></p>
<table class="table-sm">
    <thead>
        <tr>
            <th scope="col">Abbrev</th>
            <th scope="col">Day</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>U</td>
            <td>Sunday</td>
        </tr>
        <tr>
            <td>M</td>
            <td>Monday</td>
        </tr>
        <tr>
            <td>T</td>
            <td>Tuesday</td>
        </tr>
        <tr>
            <td>W</td>
            <td>Wednesday</td>
        </tr>
        <tr>
            <td>R</td>
            <td>Thursday</td>
        </tr>
        <tr>
            <td>F</td>
            <td>Friday</td>
        </tr>
        <tr>
            <td>S</td>
            <td>Saturday</td>
        </tr>
    </tbody>
</table>

